/**
 *
 * Interface定義
 *
 */
import * as H from "history";
import { AdminEntity } from "src/firebase/db/Admins";

export interface ChildrenProps {
  children: React.ReactNode;
}

export interface HistoryProps {
  history: H.History<any>;
}

export type DefaultPageProps = HistoryProps & {
  user: AdminEntity;
  login_shop_id: string;
  isSignIn: boolean;
  handleLogOut: Function;
  goBackUrl: Function;
  pushUrl: Function;
};

export enum Status {
  SUCCESS,
  FAILURE,
  INVALID,
}

export interface InputFormProps {
  inputType: "text" | "password" | "number" | "tel" | "search";
  inputValue: any;
  placeholder: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  isError: boolean;
  isDisabeld?: boolean;
  autoComplete?: string;
  min?: number;
  max?: number;
}

export interface InputAutoSuggestFormProps {
  suggestions: string[];
  onSuggestionsFetchRequested: Function;
  onSuggestionsClearRequested: Function;
  onSuggestionSelected: Function;
  renderSuggestion?: Function;
  inputType: "text" | "password" | "number" | "tel" | "search";
  inputValue: any;
  placeholder: string;
  onChange?: (value: string) => void;
  isError: boolean;
  isDisabeld: boolean;
}

export interface TextAreaProps {
  rows: number;
  max: number;
  inputValue: any;
  placeholder: string;
  onChange: (value: string) => void;
  isError: boolean;
  isDisabeld?: boolean;
}

export interface SelectBoxProps {
  id: string;
  className?: string;
  placeholder?: string;
  inputValue: any;
  onChange: (value: string) => void;
  options: {
    [value: string]: string;
  }[];
}

export interface RevenuePreviewDataProps {
  date: string;
  orderNumber: string;
  breadId: string;
  name: string;
  type: string;
  quantity: number;
  amount: number;
}
export interface RevenueReportDataProps {
  userId: string;
  date: string;
  orderNumber: string;
  time: string;
  type: string;
  name: string;
  price: number;
  quantity: number;
  amount: number;
}
